import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faTelegram } from '@fortawesome/free-brands-svg-icons';

const slideDown = keyframes`
  from { transform: translateY(-100%); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 1rem 2rem;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(10px);
  z-index: 1000;
  border-bottom: 2px solid rgba(255, 0, 0, 0.3);
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;

  @media (max-width: 768px) {
    padding: 0.75rem 1.5rem;
  }

  @media (max-width: 480px) {
    padding: 0.5rem 1rem;
  }
`;

const shimmer = keyframes`
  0% { background-position: -200% center; }
  100% { background-position: 200% center; }
`;

const wave = keyframes`
  0%, 100% { transform: rotate(0deg); }
  25% { transform: rotate(-10deg); }
  75% { transform: rotate(10deg); }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  .logo-text {
    font-size: 1.5rem;
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
    letter-spacing: 2px;
    background: linear-gradient(45deg, #ff0000, #ff4444);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    gap: 0.5rem;

    span {
      font-size: 0.8em;
      color: #ff0000;
      -webkit-text-fill-color: #ff0000;
    }

    @media (max-width: 480px) {
      font-size: 1.2rem;
    }
  }

  img {
    height: 40px;
    width: auto;
    border-radius: 50%;
    border: 2px solid rgba(255, 0, 0, 0.3);
    transition: all 0.3s ease;

    &:hover {
      transform: rotate(10deg);
      border-color: rgba(255, 0, 0, 0.6);
    }

    @media (max-width: 480px) {
      height: 32px;
    }
  }
`;

const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
`;

const Nav = styled.nav`
  display: flex;
  gap: 1.5rem;
  align-items: center;

  @media (max-width: 768px) {
    gap: 1rem;
  }

  a {
    color: #fff;
    text-decoration: none;
    font-size: 1rem;
    text-transform: uppercase;
    font-weight: 500;
    letter-spacing: 1px;
    padding: 0.5rem 1rem;
    border-radius: 20px;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    background: rgba(255, 0, 0, 0.1);
    border: 1px solid rgba(255, 0, 0, 0.2);

    &:hover {
      background: rgba(255, 0, 0, 0.2);
      transform: translateY(-2px);
      border-color: rgba(255, 0, 0, 0.4);
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.2),
        transparent
      );
      transition: 0.5s;
    }

    &:hover::before {
      left: 100%;
    }

    @media (max-width: 480px) {
      font-size: 0.9rem;
      padding: 0.4rem 0.8rem;
    }
  }
`;

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <HeaderContainer>
      <LogoContainer>
        <img src="/tpepe.png" alt="TETE" />
        <div className="logo-text">
          TETE <span>$TETE</span>
        </div>
      </LogoContainer>
      <Nav>
        <a href="https://t.me/TETESOLCTO" target="_blank" rel="noopener noreferrer">
          Join Us 🚀
        </a>
        <a href="https://dexscreener.com/solana/878fuwoov1rw4mcewwphlgafdntg9jxzwvuadkrzhzky" target="_blank" rel="noopener noreferrer">
          Chart 📈
        </a>
      </Nav>
    </HeaderContainer>
  );
};

export default Header;
